import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';

const ContentWrapper = styled( Paper )`
  margin: ${props => props.theme.space[12]} 0;
  padding: ${props => props.theme.space[10]};
  position: relative;
    
    & p {
      line-height: 1.61em;
      margin-bottom: ${props => props.theme.space[9]};
      max-width: ${props => props.theme.space[23]};
    }

    & h1, h2, h3, h4, h5, h6 {
      margin: ${props => props.theme.space[7]} 0 ${props => props.theme.space[12]};
    }
    
    & img {
      max-width: 100%;
    }

`;

export default ContentWrapper;



// WEBPACK FOOTER //
// ./src/components/styles/ContentWrapper.js